import path from 'node:path';
import { dependenciesUpdater } from '@wix/gena';
import { BLOCKS_TYPES_PATH } from '@wix/cli-app-definitions';
import type { WixConfig } from '@wix/cli-app-definitions';
import { saveWixConfig } from '../../../../files/wix.config.js';
import { readTSConfig, saveTSConfig } from '../../../../files/tsconfig.js';

const BLOCKS_SUPPORT_TEMPLATE = path.resolve(
  __dirname,
  '../templates/blocks-support'
);

export async function enableBlocksInProject(
  projectFolder: string,
  config: WixConfig
) {
  await saveWixConfig(projectFolder, {
    ...config,
    blocks: {
      uiRevision: '',
    },
  });

  const tsconfig = readTSConfig(projectFolder);

  if (!tsconfig.include?.includes(BLOCKS_TYPES_PATH)) {
    await saveTSConfig(projectFolder, {
      ...tsconfig,
      include: [...(tsconfig.include ?? []), BLOCKS_TYPES_PATH],
    });
  }

  const newDependencies = await dependenciesUpdater({
    projectFolder,
    dependenciesJsonPath: path.join(
      BLOCKS_SUPPORT_TEMPLATE,
      'dependencies.json'
    ),
  });

  return { newDependencies, newFiles: [] };
}
